/**
 * All our keys (ids) use the string pattern
 * `{prefix}{number}` make sure it's sorted properly by number
 */
export const sortKeys = (keys: string[]) => {
  return keys.sort((a, b) => {
    return Number(a.replace(/[a-z]/g, '')) - Number(b.replace(/[a-z]/g, ''));
  })
}

export const increaseId = <T extends string>(id: string): T => {
  const matchNumber = id.match(/\d+/);

  if (!matchNumber || matchNumber.length !== 1) {
    throw new Error(`Error (increaseId): Could not find number match for id '${id}'.`);
  }

  const number = Number(matchNumber[0]);

  const prefix = id.replace(matchNumber[0], '');

  return `${prefix}${number+1}` as T;
}

export const decreaseId = <T extends string>(id: string): T => {
  const matchNumber = id.match(/\d+/);

  if (!matchNumber || matchNumber.length !== 1) {
    throw new Error(`Error (decreaseId): Could not find number match for id '${id}'.`);
  }

  const number = Number(matchNumber[0]);
  // Our Ids are indexed by 1, so we can only decrease from 2 onwards
  if (number < 2) {
    throw new Error(`Error (decreaseId): Cannot decrease id lower than 2. (${id})`);
  }

  const prefix = id.replace(matchNumber[0], '');

  return `${prefix}${number-1}` as T;
}